'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _colors = require('../../../constants/colors');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PolicyIssueIcon = function (_React$Component) {
    _inherits(PolicyIssueIcon, _React$Component);

    function PolicyIssueIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PolicyIssueIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PolicyIssueIcon.__proto__ || Object.getPrototypeOf(PolicyIssueIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary) {
            return _react2.default.createElement(
                'svg',
                { xmlns: 'http://www.w3.org/2000/svg', width: '87.24', height: '99.999', viewBox: '0 0 87.24 99.999' },
                _react2.default.createElement(
                    'g',
                    { id: 'Insurance_Policies', 'data-name': 'Insurance Policies', transform: 'translate(0 -0.001)' },
                    _react2.default.createElement('path', { id: 'Path_12544', 'data-name': 'Path 12544', d: 'M82.6,7.89A100.264,100.264,0,0,0,4.61,7.9,7.891,7.891,0,0,0,0,15.11V47.98A53.158,53.158,0,0,0,33.94,97.31l4.5,1.73a14.455,14.455,0,0,0,10.36,0l4.5-1.73A53.169,53.169,0,0,0,87.24,47.98V15.12A7.9,7.9,0,0,0,82.6,7.89Zm1.72,40.09A50.227,50.227,0,0,1,52.25,94.59l-4.5,1.73a11.505,11.505,0,0,1-8.27,0l-4.5-1.73A50.242,50.242,0,0,1,2.91,47.98V15.1a4.96,4.96,0,0,1,2.87-4.53,97.254,97.254,0,0,1,75.64-.01,4.977,4.977,0,0,1,2.9,4.55Z', fill: _colors.Colors.Primary }),
                    _react2.default.createElement('path', { id: 'Path_12545', 'data-name': 'Path 12545', d: 'M58.83,55.48C58.83,49.15,52.18,44,44,44c-6.55,0-11.88-3.85-11.88-8.58,0-4.65,5.17-8.43,11.64-8.56a1.333,1.333,0,0,0,.28.03,1.055,1.055,0,0,0,.31-.04,12.937,12.937,0,0,1,10.56,5.09,1.456,1.456,0,1,0,2.32-1.76,15.882,15.882,0,0,0-11.74-6.23v-5.2a1.46,1.46,0,0,0-2.92,0v5.24c-7.5.57-13.38,5.47-13.38,11.43,0,6.34,6.64,11.49,14.8,11.49,6.57,0,11.92,3.84,11.92,8.56,0,4.63-5.13,8.4-11.56,8.56a1.648,1.648,0,0,0-.32-.04,1.345,1.345,0,0,0-.35.05,12.971,12.971,0,0,1-10.57-5.09,1.456,1.456,0,0,0-2.32,1.76,15.843,15.843,0,0,0,11.78,6.21v5.21a1.46,1.46,0,0,0,2.92,0V66.9C52.97,66.32,58.83,61.42,58.83,55.48Z', fill: _colors.Colors.Secondary })
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PolicyIssueIcon, [{
        key: 'render',
        value: function render() {
            var size = this.props.size || _sizes.Sizes.md;
            size = (0, _getSize2.default)(size);
            return _react2.default.createElement(
                _layout2.default,
                { size: 100 },
                this.getIcon(null, null, this.props.primary)
            );
        }
    }]);

    return PolicyIssueIcon;
}(_react2.default.Component);

exports.default = PolicyIssueIcon;